import { Rates } from '../../services';
import { createRestSlices, applyReducers } from './rest';
import copySlice from './rates/copy';
import deleteAllSlice from './rates/deleteAll';

const {
    initialState,
    createReducer, getReducer, listReducer,
    updateReducer, deleteReducer,
    createAction, getAction, listAction,
    updateAction, deleteAction
} = createRestSlices(Rates);

const ratesInitialState = {
    ...initialState,
    isCopyingRates: false,
    hasCopyingRatesError: false,
    isDeletingAllRates: false,
    hasDeleteAllRatesError: false,
    deleteAllRatesErrorMessage: '',
};

/* Export reducer */
export default (state = ratesInitialState, action) => {
    return applyReducers(state, action, [
        createReducer, getReducer, listReducer,
        updateReducer, deleteReducer,
        copySlice.copyRatesReducer,
        deleteAllSlice.deleteAllRatesReducer,
    ]);
}

/* Export CRUD actions */
export const createRate  = createAction;
export const loadRate    = getAction;
export const loadRates   = listAction;
export const updateRate  = updateAction;
export const deleteRate  = deleteAction;

export const copyRates = (payload) => (dispatch) => {
    return copySlice.copyRatesAction(payload)(dispatch).then(() => {
        dispatch(loadRates({ account_id: payload.target_id }));
    });
};

export const copyRatesSequence = (payloads) => (dispatch) => {
    if (!payloads.length) {
        return Promise.resolve();
    }
    const targetId = payloads[0].target_id;
    return copySlice.copyRatesSequenceAction(payloads)(dispatch).then(() => {
        dispatch(loadRates({ account_id: targetId }));
    });
};

export const deleteAllRates = (accountId) => (dispatch) => {
    return deleteAllSlice.deleteAllRatesAction(accountId)(dispatch).then(() => {
        dispatch(loadRates({ account_id: accountId }));
    });
};
